<div class="confirm-modal">
  <app-common-modal-form
    header="Mark as Lodged"
    icon=""
    confirmText="Save"
    closeText="Cancel"
    (close)="close()"
    (confirm)="save()"
  >
    <div class="message mb-4">
      Changing the ASIC Status to Lodged will not lodge the form with ASIC. Provide the ASIC document number for the
      lodgement.
    </div>

    <div class="form-group">
      <app-input
        label="ASIC Document Number"
        [formControl]="asicNumberControl"
        [customErrors]="customErrors"
      />
    </div>
  </app-common-modal-form>
</div>
